import microuniversoApi from "app/api/microuniversoApi";
import { Breadcrumb2Container } from "app/components/breadcrumb2/Breadcrumb2Container";
import { RespostaExpedicao } from "app/types/pesquisa-orcamento/sub-consultas-notas-fiscais/Expedicao";
import { DadosNotaFiscal } from "app/types/pesquisa-orcamento/consultas/NotasFiscais";
import { tratamentoErroPadrao } from "app/use-cases";
import { Dict } from "app/utils/Dict";
import globalMU from "globalMU";
import React, { useEffect, useRef, useState } from "react";
import { NotasFiscaisExpedicao } from "./NotasFiscaisExpedicao";
import { DadosDaPesquisaOrcamento } from "app/types/pesquisa-orcamento/PesquisaOrcamento";
import { useMenuConsultasPesquisaOrcamento } from "app/components/pesquisa-orcamento/menu-consultas-pesquisa-orcamento/useMenuConsultasPesquisaOrcamento";
import { useMenuSubConsultasNotaFiscal } from "app/components/pesquisa-orcamento/menu-sub-consultas-nota-fiscal/useMenuSubConsultasNotaFiscal";

export type NotasFiscaisExpedicaoContainerProps = {
    notaFiscalSelecionada: Partial<DadosNotaFiscal>
    orcamentoSelecionado: Partial<DadosDaPesquisaOrcamento>
    passos: Dict<string, () => void>,
    onRemover?: () => void,
    onVoltar: () => void,
}

export const NotasFiscaisExpedicaoContainer = (props: NotasFiscaisExpedicaoContainerProps) => {

    const [dados, setDados] = useState<RespostaExpedicao[]>([]);

    const passosInterno = useRef<Dict<string, () => void>>(new Dict(Object.assign({}, props.passos.map)))

    const onObterDadosExpedicao = async () => {
        try {
            globalMU.blockUI();
            const resultado = await microuniversoApi.NotaFiscalSaida.Expedicao(
                Number(props.notaFiscalSelecionada.Codigo)
            );

            if (("Error" in resultado)) {
                onVoltar();
                return
            }

            setDados(resultado);
        }
        catch (e) {
            tratamentoErroPadrao(e);
        }
        finally {
            globalMU.unblockUI();
        }
    }

    const onPassoSelecionado = (passo: string) => {
        props.onRemover()
        passosInterno.current.get(passo)()
    }

    const onVoltar = () => {
        props.onRemover()
        props.onVoltar()
    }

    useMenuConsultasPesquisaOrcamento({
        onVoltar:  props.onVoltar,
        orcamentoSelecionado: props.orcamentoSelecionado,
        passos: new Dict(Object.assign({}, props.passos.remove("Notas Fiscais").map)),
    })

    useMenuSubConsultasNotaFiscal({
        notaFiscalSelecionada: props.notaFiscalSelecionada,
        orcamentoSelecionado: props.orcamentoSelecionado,
        onVoltar: () => props.onVoltar(),
        passos: props.passos
    })

    useEffect(() => {
        passosInterno.current.set("Notas Fiscais", () => props.onVoltar())
        passosInterno.current.set("Expedição", () => { })
        onObterDadosExpedicao();
    }, [])


    return (
        <>
            <Breadcrumb2Container
                passos={passosInterno.current.keysToList()}
                exibirBotaoLimpar={false}
                exibirBotaoVoltar={true}
                id="NotasFiscaisExpedicaoContainer"
                onPassoSelecionado={onPassoSelecionado}
                onBotaoVoltarClicado={() => onVoltar()}
            />

            <NotasFiscaisExpedicao expedicoes={dados} />
        </>
    )
}